import { c as _c } from "react/compiler-runtime";
import React from 'react';
import type { CmsImageProps } from '@/components/CmsImage';
import { CmsImage } from '@/components/CmsImage';
export function FocusImage(t0) {
  const $ = _c(12);
  let inStyle;
  let props;
  if ($[0] !== t0) {
    ({
      style: inStyle,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = inStyle;
    $[2] = props;
  } else {
    inStyle = $[1];
    props = $[2];
  }
  const focusPointX = props?.focusPoint?.percentageX;
  const focusPointY = props?.focusPoint?.percentageY;
  let t1;
  if ($[3] !== focusPointX || $[4] !== focusPointY) {
    t1 = focusPointX && focusPointY ? {
      objectFit: "cover",
      objectPosition: focusPointX && focusPointY ? `${focusPointX}% ${focusPointY}%` : "50% 50%",
      height: "100%",
      width: "100%"
    } : undefined;
    $[3] = focusPointX;
    $[4] = focusPointY;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== inStyle || $[7] !== t1) {
    t2 = {
      ...inStyle,
      ...t1
    };
    $[6] = inStyle;
    $[7] = t1;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  const style = t2;
  let t3;
  if ($[9] !== props || $[10] !== style) {
    t3 = props?.link ? <CmsImage {...props} style={style} /> : null;
    $[9] = props;
    $[10] = style;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
}